import { render, staticRenderFns } from "./Form8.vue?vue&type=template&id=51fd1e6f&"
import script from "./Form8.vue?vue&type=script&lang=js&"
export * from "./Form8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports